import { onComposeStateChange } from '../actions/publicActions';
import { openComposeInSxS } from '../actions/publicLazyActions';
import getOrCreateSxSStoreData from '../store/Store';
import { mutator } from 'satcheljs';

function composeStateMutator(actionMessage: { composeId: string; sxsId: string }) {
    const { composeId, sxsId } = actionMessage;
    getOrCreateSxSStoreData(sxsId).composeId = composeId;
}

mutator(openComposeInSxS, composeStateMutator);
mutator(onComposeStateChange, composeStateMutator);
